const nav = {
	init: () => {
		const hamburger = document.querySelector('.hamburger');
		if (!hamburger) return;
		const svg = hamburger.querySelector('svg');
		const container = document.querySelector('.nav-toggle');
		const links = container.querySelectorAll('a');

		hamburger.addEventListener('click', () => {
			if (svg.classList.contains('lucide-menu')) {
				svg.classList.remove('lucide-menu');
				svg.classList.add('lucide-x');
				container.classList.remove('hidden');
			} else {
				nav.closeNav(svg, container);
			}
		});

		links.forEach(link => {
			link.addEventListener('click', () => {
				nav.closeNav(svg, container);
			})
		})
	},

	closeNav: (svg, container) => {
		svg.classList.add('lucide-menu');
		svg.classList.remove('lucide-x');
		container.classList.add('hidden');
	}
};

export default nav;